import { gql } from '@apollo/client';

export const ALL_POPULATION_GROUPS = gql`
  query getPopulationGroups {
    populationGroups: getPopulationGroups {
      id
      name
    }
  }
`;
